import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {
  imageUrlAdapterAspectRatios,
  imageUrlAdapterImageTypes,
  imageUrlAdapterTransformTypes,
  useImageUrlAdapter
} from '@adv-mt/mt-hook-use-image-url-adapter'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import MediaFigure, {mediaFigureBorderTypes} from '@adv-mt/mt-media-figure'

const PLACEHOLDER_HEIGHT_MOBILE = 200
const PLACEHOLDER_HEIGHT_DESKTOP = 400

export const SingleImage = ({imageUrl, imageCaption}) => {
  const getImageUrlAdapted = useImageUrlAdapter()
  const {domain} = useContext(Context)
  const domainConfig = domain.get('config')
  const {ARTICLE_BODY_IMAGE_WIDTH} = domainConfig.get('editorial')
  const isMobile = domainConfig.get('isMobile')
  const initialMediaQueryMatch = {
    defaultMatches: !isMobile
  }
  const isTabletOrHigher = useMediaQuery(useMediaQueryBreakpoints.sm, initialMediaQueryMatch)
  const imageType = isTabletOrHigher
    ? imageUrlAdapterImageTypes.ARTICLE_BODY
    : imageUrlAdapterImageTypes.MOBILE_ARTICLE_BODY

  const {images: mainTransformedImage} = getImageUrlAdapted({
    images: [{src: imageUrl}],
    options: {
      aspectRatio: imageUrlAdapterAspectRatios.WIDE_SCREEN,
      imageType,
      imageWidth: ARTICLE_BODY_IMAGE_WIDTH,
      transformType: imageUrlAdapterTransformTypes.DEVICE_CROP
    }
  })

  const dynamicImageHeight = isTabletOrHigher ? PLACEHOLDER_HEIGHT_DESKTOP : PLACEHOLDER_HEIGHT_MOBILE
  const dynamicRenderingProps = {
    height: dynamicImageHeight,
    rootMargin: `${dynamicImageHeight}px 0px`
  }

  return (
    <MediaFigure
      borderType={mediaFigureBorderTypes.ROUNDED}
      caption={imageCaption}
      dynamicRenderingProps={dynamicRenderingProps}
      images={mainTransformedImage}
    />
  )
}

SingleImage.propTypes = {
  imageUrl: PropTypes.string,
  imageCaption: PropTypes.string
}
